<template>
  <div
    class="column has-text-centered opportunity-item"
    :style="{ color: mentoringIsActive ? 'black' : '#d1d1d1' }"
  >
    <b-icon
      icon="comments"
      :style="{ color: mentoringIsActive ? 'black' : '#d1d1d1' }"
    ></b-icon>
    <br />

    <span>Mentoria</span>
  </div>
</template>

<script>
export default {
  props: ["mentoringIsActive"]
};
</script>

<style scoped>
div {
  font-size: 1rem;
}
</style>
